<template>
  <div class="mainPage">
    <div class="agentTip" v-if="!isChrome">
      <span>建议使用Chrome浏览器，以获得最佳体验</span>
      <div class="closeTip" @click="isChrome = true">×</div>
    </div>
    <div class="content">
      <ul class="course_list">
        <li v-for="(v, i) in courseList" :key="i">
          <div class="course_top">
            <img :src="require(`../img/epidemic_psychological_counse/cover${i+1}.png`)" alt="" class="cover">
            <div class="course_info">
              <div class="type">{{typeArr[i]}}</div>
              <div class="course_name">{{v.name}}</div>
              <div class="teacher">{{v.teacher_name}}</div>
              <div class="teacher_title">{{v.teacher_title}}</div>
            </div>
          </div>
          <div class="course_bottom">
            <div class="time_con">
              <span class="time">{{new Date(v.start_time).Format('YYYY年MM月DD日')}}（{{getWeek(new Date(v.start_time))}}）  北京时间 {{new Date(v.start_time).Format('hh:mm')}}-{{new Date(v.end_time).Format('hh:mm')}}</span>
              <span class="status" v-show="v.customStatus == 2">（直播已结束）</span>
            </div>
            <div class="course_status">
              <div class="replay_con" v-if="v.customStatus == 2 && v.status == 3" @click="replay(v.video_url, v.id)">
                <img src="../img/epidemic_psychological_counse/play.png" alt="">
                <span>课程回放</span>
              </div>
              <div class="zoom_con" v-else>
                <div class="zoom_left">
                  <div>观众与会链接：</div>
                  <div class="link">
                    <a href="https://zoom.us/j/98662780670?pwd=c2JZNklqSHVGRDgremI5a3dJMk9ydz09" target="_blank">加入ZOOM会议</a>
                  </div>
                  <div>会议号：986 6278 0670</div>
                  <div>密码：445931</div>
                </div>
                <img src="../img/epidemic_psychological_counse/zoom.png" alt="" class="zoom_icon">
              </div>
            </div>
            <div class="course_desc">
              {{v.describe}}
            </div>
          </div>
        </li>
      </ul>
    </div>


    <div class="footer">
      <img src="../img/epidemic_psychological_counse/copyright.png" alt="">
    </div>

    <transition name="fade">
        <div id="videoPlayWrapper" v-if="isPlay">
            <div class="videoContent">
                <div class="closeVideo" @click="closeVideo()">×</div>
                <ali-player
                v-if="isPlay"
                :useFlashPrism="false"
                :useH5Prism='true'
                :autoplay="true"
                :isLive="false"
                :rePlay="false"
                :showBuffer="true"
                showBarTime="5000"
                width="80%" 
                height="700px" 
                controlBarVisibility="always"
                :source="currentVideoUrl"></ali-player>
            </div>
        </div>
    </transition>
  </div>
</template>

<script>
import Qs from 'qs'
import aliPlayer from './aliplayer'

export default {
  components: {
    aliPlayer
  },
  data () {
    return {
      isChrome: true,
      isLogin: false,
      isPlay: false,
      currentVideoUrl: '',
      user: {
        username: '',
        email: ''
      },
      subject_info: {},
      courseList: [],
      subject_id: null,
      beforeTime: 30, // 提前可进入直播间时间
      afterTime: 30, // 延后关闭直播间时间
      typeArr: [
        '疫情防护讲座一',
        '心理辅导讲座一',
        '心理辅导讲座二',
        '疫情防护讲座二'
      ]
    }
  },
  created () {
    // this.subject_id = this.$route.query.id
    // this.subject_id = 117
    this.subject_id = 131
    // this.customCheckLogin()
    this.getCourseInfo(this.subject_id)
    this.checkChrome()
  },
  methods: {
    tolive (url) {
        window.open(url)
    },
    toLogin () {
        window.location.href =
        this.baseUrl +
        "user/api/login?" +
        "callback=" +
        encodeURIComponent(window.location.href);
    },
    toRegister () {
        window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
    },
    customCheckLogin () {
        this.checkLogin().then(res => {
            if(res.data.success){
                this.isLogin = true
                this.user = res.data.data
            } else {
                this.isLogin = false
            }
            this.getCourseInfo(this.subject_id)
        }).catch((r) => {
            console.log(r)
        })
    },
    toLogOut () {
        this.$utils.get('/user/api/logout').then(res => {
            if(res.data.success) {
                this.isLogin = false
            }
        })
    },
    getWeek(timedat) {  //timedat参数格式：   getWeek（new Date("2017-10-27" )）
      var week
      if(timedat.getDay() == 0) week = "星期日"

      if(timedat.getDay() == 1) week = "星期一"

      if(timedat.getDay() == 2) week = "星期二"

      if(timedat.getDay() == 3) week = "星期三"

      if(timedat.getDay() == 4) week = "星期四"

      if(timedat.getDay() == 5) week = "星期五"

      if(timedat.getDay() == 6) week = "星期六"

      return week
    },
    // 获取专题信息
    getSubjectInfo (id) {
        this.$utils.get('/subject/subject/read', {
            id: id
        }).then(res => {
            if(res.data.success) {
                this.subject_info = res.data.data
            }
        }).catch((r) => {
            console.log(r)
        })
    },
    // 获取课程列表
    getCourseInfo (id) {
        this.$utils.get('/subject/lesson/getlist', {
            subject_id: id,
            limit: 200
        }).then(res => {
            if(res.data.success) {
                var now = new Date().getTime()
                var endTime = now - this.afterTime * 60 * 1000;
                var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                res.data.data.list.forEach(e => {
                    e.isOrder = false
                    e.customStatus = 0
                    if (nowBeforeFiveMin > e.start_time) {
                        e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                    }

                    if (endTime > e.end_time) {
                        e.customStatus = 2
                    }

                })
                this.courseList = res.data.data.list
                // this.checkOrdeList()
            }
        }).catch((r) => {
            console.log(r)
        })
    },
    // 检查可预约直播间
    checkOrdeList () {
        const orderRoomId = []
        this.courseList.forEach(e => {
            if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                orderRoomId.push(e.room_id)
            }
        })
        this.checkRoomsIsOrder(orderRoomId)
    },
    // 检查用户直播间状态
    checkRoomsIsOrder (arr) {
        const data = Qs.stringify({
            rooms: arr.toString(),
            user: this.user.email
        })
        this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/get_user_rooms'+"?time=" +new Date().valueOf(), data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            if (res.data.code == 0) {
                this.courseList.forEach((e, index) => {
                    if (res.data.data.hasOwnProperty(e.room_id)) {
                        this.courseList[index].isOrder = true
                        this.$set (this.courseList, index, this.courseList[index])
                    }
                })
            }
        }).catch((r) => {
            console.log(r)
        })
    },
    join(item, index, islive) {
        if(!this.isLogin) {
            this.toLogin()
            return
        }
        const data = Qs.stringify({
            room_id: item.room_id,
            user: this.user.email,
            secret: "03198325b8b61ccc3413cf7e754febea",
            key: "zyz",
            username: this.user.username,
            realname: this.user.username
        })
        this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/add_user'+"?time=" +new Date().valueOf(), data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res => {
            if (res.data.code == 0) {
                this.courseList[index].isOrder = true
                this.$set (this.courseList, index, this.courseList[index])
                if (islive) {
                    window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
                }
            }
        }).catch((r) => {
            console.log(r)
        })
    },
    joinToLive(item, index) {
        if(!this.isLogin) {
            this.toLogin()
            return
        }
        if(!item.isOrder) {
            this.join(item, index, true)
        }else {
            window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
        }
    },
    replay(url, id) {
      this.isPlay = true
      this.currentVideoUrl = url
      this.$utils.get('/subject/lesson/setrecordnotlogin', {
        lesson_id: id
      }).then(res => {
      })
    },
    closeVideo() {
      this.isPlay = false
    },
    checkChrome() {
        var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
        if (!isChrome) {
            this.isChrome = false
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.mainPage {
  width: 100%;
  text-align: center;
  position: relative;
  min-height: 100vh;
  background: url('../img/epidemic_psychological_counse/banner.png') no-repeat top center;
  background-size: auto 834px;
  background-color: #0953a7;
  overflow: hidden;
  .agentTip {
      width: 100%;
      height: 70px;
      line-height: 70px;
      background-color: #ffe6a1;
      text-align: center;
      position: absolute;
      z-index: 5;
      color: #c40000;
  }
  .agentTip .closeTip {
      position: absolute;
      right: 24px;
      top: 0px;
      font-size: 30px;
      color: #282828;
      cursor: pointer;
  }
  .content {
    width: 1200px;
    margin: auto;
    margin-top: 320px;
    min-height: calc(100vh - 514px);
    .course_list {
      li {
        width: 100%;
        background-color: #eff0f5;
        box-shadow: 0px 10px 20px 0px 
          rgba(0, 0, 0, 0.3);
        border-radius: 30px;
        padding-top: 70px;
        padding-bottom: 90px;
        padding-left: 60px;
        box-sizing: border-box;
        margin-bottom: 56px;
        .course_top {
          overflow: hidden;
          .cover {
            width: 384px;
            display: block;
            float: left;
            margin-right: 59px;
          }
          .course_info {
            display: block;
            text-align: left;
            padding-top: 43px;
            .type {
              font-size: 16px;
              color: #1070c0;
              font-weight: bold;
              padding: 10px 14px;
              background-color: #f5b945;
              display: inline-block;
            }
            .course_name {
              font-size: 40px;
              font-weight: bold;
              color: #000000;
              margin-top: 37px;
              line-height: 1.4;
            }
            .teacher {
              font-size: 30px;
              font-family: SourceHanSansCN-Medium;
              color: #1070c0;
              margin-top: 37px;
            }
            .teacher_title {
              font-size: 16px;
              color: #636c77;
              margin-top: 32px;
            }
          }
        }
        .course_bottom {
          margin-top: 40px;
          .time_con {
            background-color: #f5b945;
            height: 100px;
            line-height: 100px;
            padding-left: 35px;
            .time {
              font-size: 30px;
              font-weight: bold;
              color: #1070c0;
              vertical-align: middle;
            }
            .status {
              font-size: 18px;
              color: #282828;
              letter-spacing: 1px;
              vertical-align: middle;
            }
          }
          .course_status {
            background-color: #ffffff;
            .replay_con {
              padding: 27px 0 27px 36px;
              text-align: left;
              cursor: pointer;
              img {
                width: 47px;
                vertical-align: middle;
                margin-right: 15px;
              }
              span {
                font-size: 20px;
                font-weight: bold;
                color: #000000;
                vertical-align: middle;
              }
            }
            .zoom_con {
              padding: 37px 0 37px 34px;
              text-align: left;
              font-size: 18px;
              overflow: hidden;
              .zoom_left {
                float: left;
                div {
                  margin-bottom: 18px;
                  color: #364347;
                }
                .link {
                  text-decoration: underline;
                  cursor: pointer;
                  a {
                    color: #009bff;
                  }
                }
              }
              .zoom_icon {
                float: right;
                margin-right: 100px;
              }
            }
          }
          .course_desc {
            font-size: 16px;
            color: #636c77;
            line-height: 30px;
            text-indent: 1em;
            margin-top: 45px;
            padding: 0 100px 0 36px;
            text-align: left;
          }
        }
      }
    }
  }


  .footer {
    padding-bottom: 110px;
    padding-top: 24px;
    img {
      width: 380px;
    }
  }
  #videoPlayWrapper {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 999;
  }
  #videoPlayWrapper .closeVideo {
      position: absolute;
      right: 20px;
      top: 10px;
      font-size: 50px;
      color: #fff;
      cursor: pointer;
  }
  .videoContent {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
  }
  .videoContainer {
      text-align: center;
      width: 100%;
  }
  .videoContainer video {
      width: 62%;
  }
  video::-internal-media-controls-download-button {
      display:none;
  }
  video::-webkit-media-controls-enclosure {
      overflow:hidden;
  }
  video::-webkit-media-controls-panel {
      width: calc(100% + 30px);
  }
}

</style>
